<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click.stop="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span /></td>
    <td class="no_padding">
      <input
        type="checkbox"
        :id="entity.id"
        :value="entity.id"
        @click.stop
        @change="onChange"
        :checked="isChecked"
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td :data-th="'Název zařízení' | translate">
      <strong>{{ entity.name }}</strong>
      <span v-if="entity.pre_provisioned" class="stitek" :title="$gettext('Přednastavený')">PP</span>
        <span v-if="entity.service_device" class="stitek" :title="$gettext('Servisní zařízení')">S</span>
    </td>
    <td :data-th="'MAC' | translate">
      {{ entity.last_used_mac_address }}
    </td>
    <td :data-th="'Model' | translate">
      {{ entity.model }}
    </td>
    <td :data-th="'Firmware a aplikace' | translate">
      {{ entity.firmware }}<br/>
      <span>{{entity.application}}</span>
    </td>
    <td :data-th="'Sériové číslo' | translate">
      {{ entity.serial_number }}
    </td>
    <td :data-th="'Typ' | translate">
      <entity-link :id="entity.id_type" type="deviceType">{{ entity.type_name }}</entity-link>
    </td>
    <td :data-th="'Profil' | translate">
      <entity-link :id="entity.id_profile" type="deviceProfile">{{ entity.profile_name }}</entity-link>
    </td>
    <td :data-th="'Odběratel' | translate">
      <entity-link :id="entity.id_subscriber" type="subscriberDevices">{{ entity.subscriber_name }}</entity-link>
    </td>
    <td v-if="$_readActionAllowedAll" :data-th="'Operátor' | translate">
      <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
    </td>
    <td :data-th="'Poslední start' | translate" v-html="$_date_formatFull(entity.last_start)"></td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a class="btn btn_action btn_grey btn_info" @click.stop.prevent="goToDetail($event, entity.id)" :title="$gettext('O zařízení')" target="_blank" v-translate>O zařízení</a>
        <DeviceLogViewerButton
            v-if="$_loggedUser_action_allowed('deviceLogViewer', 'read')"
            :url="deviceLogViewerUrl"
            :mac-address="entity.last_used_mac_address"
            :token="entity.device_token"
        />
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteDevice">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import DeviceLogViewerButton from "./detail/DeviceLogViewerButton.vue"
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "DeviceRow",
  mixins: [rowActions],
  components: { EntityLink, DeviceLogViewerButton},
  props: {
    entity: Object,
    selectedDevices: Array,
    deviceLogViewerUrl: String
  },
  data() {
    return {
      moduleName: 'devices',
    }
  },
    methods: {
    goToDetail(e, id) {
      this.$router.push({name: 'deviceDetail', params: {id: id}})
    },
    emitDeleteDevice() {
      this.$emit('deleteDevice', String(this.entity.id))
    },
    onChange: function (e) {
      this.$emit('input', e)
    },
  },
  computed: {
    isChecked() {
      return this.selectedDevices.indexOf(String(this.entity.id)) > -1
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/DeviceRow.vue